import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../util/AuthContext"; // Import the Auth Context
import './Pages.css'

const LoginForm = () => {
  const { isAuthenticated, login } = useContext(AuthContext); // Get login function
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = async (e) => {
    await login();
  };

  return (
    <div  className="loginForm">
      <h2>Velkommen til Hillerød frimenighed website admin side</h2>
      <button onClick={handleLogin}><h3>Login med Google</h3></button>
    </div>
  );
};

export default LoginForm;
